// extracted by mini-css-extract-plugin
export default {"clamped":"PNaupd","tooltip-content":"mfJyVo","slideDownAndFade":"XBOIme","slideLeftAndFade":"mSemLm","slideUpAndFade":"fODpWF","slideRightAndFade":"UFwkXs","tooltip-arrow":"TKvCrV"};